import React from 'react';
import { Form, Input, Row } from 'antd';
import GenericDialog from '@common/GenericDialog';

const CreateTestGroupDialog = ({
                                   open,
                                   onClose,
                                   createTestGroupForm,
                                   onCreateTestGroup,
                               }) => {
    return (
        <GenericDialog
            title="Add a new ‘Test Family’"
            open={open}
            onClose={() => {
                onClose();
                createTestGroupForm.resetFields();
            }}
            buttons={[
                {
                    name: 'Cancel',
                    extraProps: { type: 'text' },
                },
                {
                    name: 'Create',
                    callback: onCreateTestGroup,
                },
            ]}
        >
            <Form
                className="testFamilyForm"
                form={createTestGroupForm}
                labelCol={{ span: 8 }}
                wrapperCol={{ span: 16 }}
            >
                <Form.Item
                    label="Name"
                    name="testGroupName"
                    rules={[
                        { required: true, message: 'Please input a name.' },
                    ]}
                >
                    <Input placeholder="Name" />
                </Form.Item>
                <Row>
                    <Form.Item
                        label="Description"
                        name="description"
                        value="optional"
                    >
                        <Input.TextArea placeholder="Description" />
                    </Form.Item>
                </Row>
            </Form>
        </GenericDialog>
    );
};

export default CreateTestGroupDialog;
